export const screen = document.querySelector('#screen');
export const btnParent = document.querySelector('.btns');